import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SocialButton = styled(Button, { name: 'SocialButton' })({
	textTransform: 'none',
});

SocialButton.defaultProps = {
	...SocialButton.defaultProps,
	fullWidth: true,
	size: 'large',
	variant: 'outlined',
};
